
import Tenants from "@/components/tenants/Tenants.vue";
import TenantDetail from "@/components/tenants/TenantDetail.vue";

import Clients from "@/components/tenants/clients/Clients.vue";
import ClientDetail from "@/components/tenants/clients/ClientDetail.vue";

import IdentityResources from "@/components/identityResources/IdentityResources.vue";
import IdentityResourceDetail from "@/components/identityResources/IdentityResourceDetail.vue";

import ApiResources from "@/components/apiResources/ApiResources.vue";
import ApiResourceDetail from "@/components/apiResources/ApiResourceDetail.vue";

import OidcCallback from '@/components/security/OidcCallback.vue'
import OidcPopupCallback from '@/components/security/OidcPopupCallback.vue'
import OidcCallbackError from '@/components/security/OidcCallbackError.vue'
import Login from '@/components/Login.vue'

export const routes = [
         {
           name: "login",
           path: "/",
           component: Login,
           meta: { 
            requiresAuth: false,
            isPublic: true
           }
         },
         {
           name: "tenants",
           path: "/tenants",
           component: Tenants
         },
         {
           name: "tenantEdit",
           path: "/tenants/:tenantId/edit",
           component: TenantDetail
         },
         {
           name: "tenantNew",
           path: "/tenants/new",
           component: TenantDetail
         },

         {
           name: "clients",
           path: "/tenants/:tenantId/clients",
           component: Clients
         },
         {
           name: "tenantClientEdit",
           path: "/tenants/:tenantId/clients/:clientId/edit",
           component: ClientDetail
         },
         {
           name: "tenantClientNew",
           path: "/tenants/:tenantId/clients/new",
           component: ClientDetail
         },
         {
           name: "identityResources",
           path: "/identityResources",
           component: IdentityResources
         },
         {
           name: "identityResourceEdit",
           path: "/identityResources/:identityResourceId/edit",
           component: IdentityResourceDetail
         },
         {
           name: "identityResourceNew",
           path: "/identityResources/new",
           component: IdentityResourceDetail
         },
         {
           name: "apiResources",
           path: "/apiResources",
           component: ApiResources
         },
         {
           name: "apiResourceEdit",
           path: "/apiResources/:apiResourceId/edit",
           component: ApiResourceDetail
         },
         {
           name: "apiResourceNew",
           path: "/apiResources/new",
           component: ApiResourceDetail
         },
         {
           name: "oidcCallback",
           path: "/oidc-callback", // Needs to match redirectUri in your oidcSettings
           component: OidcCallback,
         },
         {
           name: "oidcPopupCallback",
           path: "/oidc-popup-callback", // Needs to match popupRedirectUri in your oidcSettings
           component: OidcPopupCallback,
         },
         {
           name: "oidcCallbackError",
           path: "/oidc-callback-error", // Needs to match redirect_uri in you oidcSettings
           component: OidcCallbackError,
           meta: { 
            requiresAuth: false,
            isPublic: true
           }
          }
       ];